<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-3">
                <label for="start-month-select">{{ $t('start-month-colon') }}</label>
                <select id="start-month-select" v-model="startSelectedMonth" @change="updateRange" class="form-control">
                    <option v-for="(month,index) in months" :value="month.value" :key="index">{{ month.label }}</option>
                </select>
            </div>
            <div class="col-md-3">
                <label for="start-year-select">{{ $t('start-year-colon') }}</label>
                <select id="start-year-select" v-model="startSelectedYear" @change="updateRange" class="form-control">
                    <option v-for="(year,index) in years" :value="year" :key="index">{{ year }}</option>
                </select>
            </div>
            <div class="col-md-3">
                <label for="end-month-select">{{ $t('end-month-colon') }}</label>
                <select id="end-month-select" v-model="endSelectedMonth" @change="updateRange" class="form-control">
                    <option v-for="(month,index) in months" :value="month.value" :key="index">{{ month.label }}</option>
                </select>
            </div>
            <div class="col-md-3">
                <label for="end-year-select">{{ $t('end-year-colon') }}</label>
                <select id="end-year-select" v-model="endSelectedYear" @change="updateRange" class="form-control">
                    <option v-for="(year,index) in years" :value="year" :key="index">{{ year }}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <button @click="toggleChartType" class="btn btn-primary mx-1 my-1">{{ this.chartType === 'line' ? $t('bar-chart') : $t('line-chart') }}</button>
                <button @click="toggleAcc" class="btn btn-primary mx-1 my-1">{{ this.accChart === 'monthly' ? $t('accumulated-chart') : $t('monthly-chart') }}</button>
            </div>
            <div class="col-md-6">
                <select v-model="currentTarget" @change="changeTargets()" class="form-control float-right my-1">
                    <option value="">{{$t('select-target')}}</option>
                    <option v-for="(term, index) in $config.getValue('schoolterms')" 
                        :key="index" 
                        :value="term">
                        {{ term.programme_name }} {{ term.schoolterm_title }}
                    </option>
                </select>
            </div>
        </div>
        <div class="row" v-if="displayNoTargetsMsg">
            <div class="col-12">
                <p>{{  $t('target-not-found') }}</p>
            </div>
        </div>
        <!--We are sending plotData, plotOptions and plotLines-->
        <!--div v-if="chartPlotted">
            <apexchart ref="chart" :options="plotOptions" :series="plotData"></apexchart>
        </div>
        <div class="row" v-else>
            <div class="col-12 mb-4">
                <div class="card border-light" style="width: 18rem; margin: 40px auto 0;">
                    <div class="card-body text-center">
                        <b-spinner 
                            variant="primary" 
                            type="grow" 
                            font-scale="7.5" 
                            class="mb-2"
                        >
                        </b-spinner>
                        <h5 class="card-title" style="color:black">{{ $t("loading") }}</h5>
                        <p class="card-text" style="color:black">
                            {{ $t('chart-loading') }}
                        </p>
                    </div>
                </div>
            </div>
            
        </div-->
        <Plotter  
            :plotData="plotData"
            :plotOptions="plotOptions"
            :plotLines="plotLines"
            :chartPlotted="chartPlotted"
        />
        <div class="row d-flex justify-content-center" v-if="chartPlotted">
            <label class="form-check-label col-auto" v-for="(line,index) in plotLines" :key="index" >
                <input type="checkbox" v-model="checkboxValues[line.name]" @change="toggleDataSeries(line.label,line.name, $event.target.checked)" class="form-check-input"> {{ line.label }} {{ checkboxValues[line] }}
            </label>
        </div>
    </div>

</template>
<script>
import ApexCharts from 'apexcharts';
import Plotter from '../Plotter/Plotter.vue';

export default {
    name: 'TimeSeries',
    props: {
        parameters : Object,
    },
    components:{
        Plotter
    },
    data() {
        return {
            startSelectedMonth: (new Date().getMonth()),
			startSelectedYear: (new Date().getFullYear()-1),
			endSelectedMonth: (new Date().getMonth()),
			endSelectedYear: new Date().getFullYear(),
			startDate: new Date(this.startSelectedYear, this.startSelectedMonth, 1),
			endDate: new Date(this.endSelectedYear, this.endSelectedMonth,1),
            chartType:'line',
            accChart: 'accumulated',
			months: [
				{ label: 'January', value: 0 },
				{ label: 'February', value: 1 },
				{ label: 'March', value: 2 },
				{ label: 'April', value: 3 },
				{ label: 'May', value: 4 },
				{ label: 'June', value: 5 },
				{ label: 'July', value: 6 },
				{ label: 'August', value: 7 },
				{ label: 'September', value: 8 },
				{ label: 'October', value: 9 },
				{ label: 'November', value: 10 },
				{ label: 'December', value: 11 }
      		],
     		years: [],
            targets: [],
            targetPlotted: false,
            currentTarget: {
            	programme_id: null ,
            	schoolyear_id: null ,
            	schoolterm_id: null
            },
            data: {
                userData: {
                    monthly :[],
                    cumulative: []
                },
                stats: {
                    monthly: [],
                    cumulative: []
                },
            },
            targetSeries: [],
            plotLines: [
                { name: this.parameters.data.data.split('.')[1], series: 'userData', type:'monthly', label: this.parameters.student.displayName, color:'blue' },
                { name: 'q1', series: 'stats', type:'monthly', label: this.$t('q1'), color: 'red' },
                { name: 'q3', series: 'stats', type:'monthly', label: this.$t('q3'), color: 'green' },
                { name: 'mean', series: 'stats', type:'monthly', label: this.$t('mean'), color: 'amber' },
                { name: 'median', series: 'stats', type:'monthly', label: this.$t('median'), color: 'yellow' }
            ],
            targetLine: [],
            bundle: [],
            accBundle: [],
            currentKey: '', //This adds an object with the selected key name in checkboxValues
            //checkboxValues: {},
            plotData : [],
            chartPlotted: false,
            displayNoTargetsMsg: false,
            plotOptions: {
				chart: {
					id: `reportChart_${this.parameters.data.data.split(".")[0]}_${this.parameters.data.data.split(".")[1]}`,
					height: 350,
					type: 'line',
					zoom: {
						enabled: false
					},
                    background: '#f3f4f6',
                    export: {
                        csv: {
                            filename: 'report',
                        },
                        svg: {
                            filename: 'report',
                        },
                        png: {
                            filename: 'report',
                        }
                    }
				},
				dataLabels: {
					enabled: false
				},
				stroke: {
					curve: 'smooth'
				},
				title: {
					text: `${this.parameters.data.caption} for ${this.parameters.student.displayName}`,
					align: 'left',
                    style:  {
                        fontSize:  '28px',
                        fontWeight:  'bold',
                        fontFamily:  undefined,
                    },
				},
				grid: {
					row: {
						colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
						opacity: 0.5
					},
				},
				xaxis: {
					categories:[],
                    decimalsInFloat: 2
				},
                yaxis: {
                    min:0,
                    decimalsInFloat: 2,
                },
                noData: {
                    text: this.$t('could-not-load-plot-data'),
                    align: 'center',
                    verticalAlign: 'middle',
                    offsetX: 0,
                    offsetY: 0,
                    style: {
                        color: undefined,
                        fontSize: '14px',
                        fontFamily: undefined
                    }
                }
			}
        };
    },
    computed: {
        initialCheckboxValues() {
        return {
            [this.parameters.data.data.split('.')[1]]: true,
            median: true,
            mean: true,
            q1: true,
            q3: true,
        };
    },
    },
    created() {
        this.checkboxValues = { ...this.initialCheckboxValues };
    },
    mounted ()  {
        //this.createChart();
        this.getPlotData();
        this.plotTarget();
        const currentYear = new Date().getFullYear();
    	for (let year = currentYear; year >= currentYear - 10; year--) {
      	this.years.push(year);
		}
		this.startDate= this.makeDate(this.startSelectedYear, this.startSelectedMonth);
		this.endDate=this.makeDate(this.endSelectedYear, this.endSelectedMonth);
    },
    methods: {
        extractYearMonth(date){ //This function is needed because the API returns dates in "YYYY-MM" format
            const month = date.getMonth()+1;
            const year = date.getFullYear();
            const yearMonth = `${year}-${month.toString().padStart(2, '0')}` //months span is 01-12, this gets the date string in "YYYY-MM" format
            return yearMonth
        },
        makeDate(year,month){
			return new Date(year,month,1);
		},
        updateRange() {
            this.startDate = new Date(this.startSelectedYear, this.startSelectedMonth , 1);
            this.endDate = new Date(this.endSelectedYear, this.endSelectedMonth , 1);
            this.updateChart();
   		},
        toggleChartType() {
            const newChartType = this.chartType === 'line' ? 'bar' : 'line';
           /* Just in case we want to get rid of the target when displaying a bar chart
            if(newChartType==='bar'){
                this.$refs.chart.hideSeries('Target');
            }*/
			if('chart' in this.$refs){
				this.$refs.chart.updateOptions({
					chart: {
						type: newChartType,
					},
				});
            }
            this.chartType = newChartType;
        },
        resetCheckboxes(){ // If we want to reset the checkboxes
            for (const key in this.checkboxValues) {
                this.$set(this.checkboxValues, key, true);
            }
        },
        toggleAcc() {
            this.resetCheckboxes();
            const newChartType = this.accChart === 'monthly' ? 'accumulated' : 'monthly';
            if (this.accChart === 'monthly') {
                this.plotData=this.accBundle;
            }
            else  {
                this.plotData=this.bundle;
            }
            this.$nextTick(() => {
            	if('chart' in this.$refs){
                    this.$refs.chart.updateOptions(this.plotOptions);
                }
            });
            this.accChart = newChartType;
        },
        toggleDataSeries(series,name,value) {
            if('chart' in this.$refs) { //toggles the series to be plotted
                this.$refs.chart.toggleSeries(series);
            }
            this.$set(this.checkboxValues, name, value); //updates the checkbox
        },
        updateChart() {
            this.bundle=[];
            this.accBundle=[]
            this.prepareData();
            this.plotter();
            this.targetPlotted=false;
            this.plotTarget();
            this.plotOptions = {
                xaxis : {
                    categories: this.monthsBetween(this.startDate, this.endDate)
                }
            };
            if(this.accChart === 'monthly'){
                this.plotData=this.bundle;
            }
            else {
                this.plotData=this.accBundle;
            }
            this.$nextTick(() => {
            	if('chart' in this.$refs){
                	this.$refs.chart.updateOptions(this.plotOptions);
                	//this.$refs.chart.updateSeries(this.plotData);
                }
            });

        },
        getPlotData(){
            this.$cfetch(`${this.$settings.APIBaseURL}/reporting/dataelement/${this.parameters.data.data.split('.')[0]}`, {
                cache: false,
                method: 'post',
                data: {
					'student_id': this.parameters.student.id ,
                	'filters': {
						'groupby': 'month' /*,
						'programme': this.parameters.student.programme ,
						'year': this.parameters.student.year ,
						*/
					}
				}
            }).then((res)=>{
                if(res.retry){
					console.error("Will retry to get plot data");
					var self = this;
                    delete self.getPlotData();
                    self.getPlotData();
				} else {
					if (res.status==='SUCCESS'){
						//This saves the API response and adds the dategroup attribute to the results
						this.data.userData = {
							monthly: Object.entries(res.result.values.monthly).map(([date, data]) => ({ ...data, dategroup: date })),
							cumulative: Object.entries(res.result.values.cumulative).map(([date, data]) => ({ ...data, dategroup: date }))
						}

						this.data.stats = {
							monthly: Object.entries(res.result.stats[this.parameters.data.data.split('.')[1]].monthly).map(([date, data]) => ({ ...data, dategroup: date })),
							cumulative: Object.entries(res.result.stats[this.parameters.data.data.split('.')[1]].cumulative).map(([date, data]) => ({ ...data, dategroup: date }))
						}

						this.targets = res.result.values.targets;
                        
						this.processData();
					} else {
						console.error('API call was unsuccesful');
					}

				}
            }).catch(error => {
                this.$log.error.call(this, error);
            });
        },
        processData () {
            if(this.chartPlotted || !this.parameters) return; //This prevents from plotting an additional empty chart

            this.prepareData();
            this.plotter(); //plotter must go before plotTarget as we need the target to be the last element of the array
            this.plotTarget();
            this.plotData=this.accBundle;
            this.plotOptions.xaxis.categories= this.monthsBetween(this.startDate, this.endDate);
            this.$nextTick(() => {
                if(!this.chartPlotted){
                    const chart = new ApexCharts(document.querySelector(`#reportChart_${this.parameters.data.data.split(".")[0]}_${this.parameters.data.data.split(".")[1]}`), this.plotOptions);
                    chart.render();

                }
            });
            this.chartPlotted=true
        },
        plotTarget () {
            if (this.currentTarget.programme_id === null){ //Default setting
                this.$users.getUserById.call(this,this.parameters.student.id).then(user => {
                    //setTimeout(() => { 
                        //Check if we have plotted a target to prevent doing it twice
						if(user.programme in this.targets && user.year in this.targets[this.parameters.student.programme]){
							const keys = Object.keys(this.targets[this.parameters.student.programme][this.parameters.student.year]);
							this.currentTarget.programme_id = this.parameters.student.programme;
							this.currentTarget.schoolyear_id = this.parameters.student.year;
							this.currentTarget.schoolterm_id = keys[keys.length - 1];
							this.targetForUser(this.parameters.student.programme,this.parameters.student.year,keys[keys.length - 1]);
							this.accBundle.push(this.createPlotLine(this.targetSeries,'target',this.$t('target'),this.$config.getColorHexByName('purple')));
							this.targetPlotted = true;
						}
                    //}, 2000);
                });
            } else {
                this.targetForUser(this.currentTarget.programme_id,this.currentTarget.schoolyear_id,this.currentTarget.schoolterm_id);
                this.accBundle.push(this.createPlotLine(this.targetSeries,'target',this.$t('target'),this.$config.getColorHexByName('purple')));
            }
        },
        changeTargets() {
			if(this.currentTarget){
                this.accBundle.pop(); //deletes the last element of the array, that is the past target
                this.bundle.pop();
                this.plotTarget();
			}
		},
        targetForUser(programme,year,term){
            this.targetSeries = [];
            if(
                programme in this.targets && year in this.targets[programme] 
                && term in this.targets[programme][year] && this.parameters.data.data.split('.')[1] in this.targets[programme][year][term]
            ) {
                
                const targetValue = this.targets[programme][year][term][this.parameters.data.data.split('.')[1]];
                let currentDate = new Date(this.startDate.getTime());

                this.endDate.setMonth(this.endSelectedMonth );// Add 1 to the month index, this is because months are labelled as 01-12
                
                while (currentDate <= this.endDate) {
                    let dateString = this.extractYearMonth(currentDate);
                    let targetData = {"target":targetValue,"dategroup":dateString};
                    this.targetSeries.push(targetData);
                    currentDate.setMonth(currentDate.getMonth() + 1); // Move to the next month
                }

                this.targetSeries.sort((a, b) => (a.dategroup > b.dategroup) ? 1 : -1);
                this.displayNoTargetsMsg = false;

            } else {
                this.displayNoTargetsMsg = true;
                this.plotData = this.plotData.filter(x => x.name != "Target");
            }
        },
        hydrateSeries(series, hydroParam) {
            let currentDate = new Date(this.startDate.getTime());
            this.endDate.setMonth(this.endSelectedMonth );
            while (currentDate <= this.endDate) {
                let dateString = this.extractYearMonth(currentDate);
                let existingData = series.find(obj => obj.dategroup === dateString); // Check if the date already exists in the array
                if (!existingData) {
                    const defaultValues = Object.keys(series[0]).reduce((obj, key) => {
                        obj[key] = hydroParam;
                        return obj;
                    }, {});
                    let newData = {...defaultValues, dategroup: dateString};
                    series.push(newData);
                }
                currentDate.setMonth(currentDate.getMonth() + 1); // Move to the next month
            }
            series.sort((a, b) => (a.dategroup > b.dategroup) ? 1 : -1);      // Sort the array by date
        },
        addUpToEndDate(series,value) {
            const result = series.reduce((acc, curr) => {
            const date = new Date(curr.dategroup);
            this.endDate.setMonth(this.endSelectedMonth+1);
            if (date <= this.endDate) {
                const lastGroup = acc[acc.length - 1];
                const accumulatedTotal = lastGroup ? lastGroup.accumulatedTotal +Number(curr[value]) : Number(curr[value]);
                acc.push({ dategroup: curr.dategroup, accumulatedTotal });
            }
            return acc;
            }, []);
            return result
        },
        createPlotLine (series,values,name=values,color) {
            let line = [];
            for (const key in series) {
                    if (series[key].dategroup >= this.extractYearMonth(this.startDate) && series[key].dategroup <= this.extractYearMonth(this.endDate)) {
                        line.push(series[key][values]);
                    }
            }
            let graph = {
                name : name,
                data : line,
                color: color
            };
            return graph;
        },
        prepareData () {
            this.targetSeries = [];
            this.plotData = [];
            ['monthly', 'cumulative'].forEach((type) => {
                this.hydrateSeries(this.data.userData[type], 0);
                this.hydrateSeries(this.data.stats[type], 0);
            });
        },
        plotter() {
            this.bundle = [];
            this.accBundle = [];
            this.plotLines.forEach(line => {
                const {name, series,type,label,color} = line;
                if (this.checkboxValues[name]) {
                    this.bundle.push(this.createPlotLine(this.data[series][type],name,label,this.$config.getColorHexByName(color)));
                    /*For now, it seems to be more economic (in terms of code) to use the hydratedSeries
                    at prepareData and then add up the data up to the end date*/
                    this.accBundle.push(this.createPlotLine(this.addUpToEndDate(this.data[series][type],name),'accumulatedTotal',label,this.$config.getColorHexByName(color)));
                }
            });
        },
        monthsBetween(startDate, endDate) {
        const months = [];
        let currentDate = new Date(startDate);
		if (endDate<=startDate) {
                this.$store.commit("openDialog", {
                    title: this.$t("oops"),
                    content: this.$t("the-starting-date-can-not-go-beyond-the-finishing-date")
                });
            }
			else {
				while (currentDate < endDate) {
					const year = currentDate.getFullYear();
					const month = currentDate.toLocaleString('default', { month: 'short' });
					months.push(`${month}-${year}`);
					currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
				}
			}
        return months;
        },
    }
}
</script>
<style>
.apexcharts-tooltip {
    background: #a7a7a7;
    color:black;
  }
  .apexcharts-menu.apexcharts-menu-open {
    background: #a7a7a7 !important;
    color:black !important;
  }
</style>
